// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wa_a bhp_b bhp_we"};